import { render, staticRenderFns } from "./SurveySendDialog.vue?vue&type=template&id=2cfef8a6&scoped=true"
import script from "./SurveySendDialog.vue?vue&type=script&lang=js"
export * from "./SurveySendDialog.vue?vue&type=script&lang=js"
import style0 from "./SurveySendDialog.vue?vue&type=style&index=0&id=2cfef8a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfef8a6",
  null
  
)

export default component.exports